import variant from 'style-utils/core/variant/variant';

export type TypographyVariants = keyof typeof variants;

export type WithUiKitTypographyVariants = {
  variant?: TypographyVariants;
};

const variants = {
  title_xl: {
    fontFamily: 'Muli',
    fontWeight: 800,
    fontSize: '2.4rem',
    lineHeight: '3rem',
  },
  light12: {
    fontWeight: 300,
    fontSize: '1.2rem',
    lineHeight: '1.4rem',
  },
  regular: {
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '1.6rem',
  },
  regular12: {
    fontWeight: 400,
    fontSize: '1.2rem',
    lineHeight: '1.6rem',
  },
  regular14: {
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: '1.8rem',
  },
  regular16: {
    fontWeight: 400,
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
  },
  medium12: {
    fontWeight: 500,
    fontSize: '1.2rem',
    lineHeight: '1.4rem',
  },
  medium14: {
    fontWeight: 500,
    fontSize: '1.4rem',
    lineHeight: '2.2rem',
  },
  medium16: {
    fontWeight: 500,
    fontSize: '1.6rem',
    lineHeight: '2.2rem',
  },
  bold: {
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: '1rem',
  },
  bold12: {
    fontWeight: 700,
    fontSize: '1.2rem',
    lineHeight: '1.4rem',
  },
  bold14: {
    fontWeight: 700,
    fontSize: '1.4rem',
    lineHeight: '1.8rem',
  },
  bold16: {
    fontWeight: 700,
    fontSize: '1.6rem',
    lineHeight: '2rem',
  },
  uBold12: {
    fontWeight: 700,
    fontSize: '1.2rem',
    lineHeight: '2.2rem',
    textDecoration: 'underline',
  },
  uBold16: {
    fontWeight: 700,
    fontSize: '1.6rem',
    lineHeight: '2.2rem',
    textDecoration: 'underline',
  },
  black14: {
    fontWeight: 900,
    fontSize: '1.4rem',
    lineHeight: '2.2rem',
  },
  H1: {
    fontFamily: 'Muli, Roboto, sans-serif',
    fontWeight: 900,
    fontSize: '4.8rem',
    lineHeight: '2.8rem',
  },
  H2: {
    fontFamily: 'Muli, Roboto, sans-serif',
    fontWeight: 900,
    fontSize: '4rem',
    lineHeight: '4.4rem',
  },
  H3: {
    fontFamily: 'Muli, Roboto, sans-serif',
    fontWeight: 900,
    fontSize: '2.4rem',
    lineHeight: '2.9rem',
  },
  H4: {
    fontFamily: 'Muli, Roboto, sans-serif',
    fontWeight: 900,
    fontSize: '1.6rem',
    lineHeight: '2rem',
  },
  H5: {
    fontFamily: 'Muli, Roboto, sans-serif',
    fontWeight: 700,
    fontSize: '1.4rem',
    lineHeight: '2rem',
  },
};

export const withUiKitTypographyVariants = variant({
  variants: variants,
});
